package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class ConvertWalmartAccountWithTokenRequestInfo(
    val vzAuthCode: String,
    val accessToken: String
)

@Serializable
@JsExport
internal data class ConvertWalmartAccountWithTokenClientRequestInfo(
    val vzAuthCode: String
)